<div class="fixed top-0 left-0 bottom-0 right-0 flex justify-center items-center z-[99] bg-black bg-opacity-40 h-screen w-screen">
    <div class="w-[792px] h-fit max-h-[calc(100vh-40px)] rounded-2xl shadow-custom bg-white !m-2 flex flex-col">
        <!-- HEADER -->
        <div class="flex justify-between items-center !mb-4 border-b border-b-palette-gray-200 !px-6 !py-4">
            <h3 class="text-lg font-semibold text-palette-gray-900">
                {{'COMMON.FLIGHT_DETAILS' | translate}}</h3>
            <div (click)="handleHidePopup()"
                class="flex items-center justify-center w-[36px] h-[36px] hover:bg-palette-gray-100 rounded-lg cursor-pointer">
                <i class="sctr-icon-x-close text-[20px] text-palette-gray-700"></i>
            </div>
        </div>
        <!-- BODY -->
        <div class="!px-6 overflow-y-auto">
            <div *ngIf="!isLoading && detailsData" class="flex flex-col !gap-4">
                <span *ngIf="!isLoading" class="text-sm text-palette-gray-700">
                    {{ ('BOOKING_ISSUE.FLIGHT_UPDATE_1' | translate) + ' ' + 
                    (detailsData?.updated_at ?? detailsData?.requested_at | formatUtcZ | dateFormat : true : true) + ' ' + getUTCUser() + 
                    '. ' +  ('BOOKING_ISSUE.FLIGHT_UPDATE_2' | translate) }}
                </span>
                <!-- Booking info -->
                <div class="border-b border-dashed">
                    <p class="text-palette-gray-900 text-base font-semibold">{{ 'BOOKING_RESERVATION.BOOKING_INFORMATION' | translate }}</p>
                    <div class="!pt-4 !pb-5 flex !gap-3 m-0">
                        <div class="flex-1 flex flex-col !gap-1">
                            <div class="flex items-center !gap-1">
                                <p class="text-sm font-normal text-palette-gray-500">
                                    {{ 'FLIGHT.PAYMENT.BOOKING_STATUS' | translate }}
                                </p>
                                <div class="relative hover:cursor-pointer">
                                    <i
                                        [position]="TooltipPosition.RIGHT"
                                        [theme]="TooltipTheme.LIGHT"
                                        [tooltip]="'FLIGHT.PAYMENT.BOOKING_STATUS_DESC' | translate"
                                        class="sctr-icon-info-circle text-palette-gray-500 text-base"></i>
                                </div>
                            </div>
                            <span class="w-fit !px-2 !py-0.5 rounded-full text-xs whitespace-nowrap {{bookingStatusStyle}}">
                                {{ 'COMMON.' + bookingStatus | translate}}
                            </span>
                        </div>
                        <div class="flex-1 flex flex-col !gap-1">
                            <p class="text-sm font-normal text-palette-gray-500">{{ 'COMMON.ORDER_ID' | translate }}</p>
                            <p class="text-sm font-semibold text-palette-gray-900">{{ id }}</p>
                        </div>
                    </div>
                </div>
                <div class="!flex flex-col">
                    <ng-container *ngIf="this.type === 'CANCEL' || this.type === 'RESCHEDULE' || this.type === 'FINDING_FLIGHT'">
                        <div class="border border-palette-gray-200 shadow-sm bg-white flex p-[7px] items-center rounded-lg text-sm font-semibold">
                            <ng-container *ngFor="let item of availableItineraries; let index = index">
                                <button (click)="changeCurrentTag(item, index)"
                                    class="min-w-[52px] rounded-lg h-9 flex justify-center items-center px-3 py-2 mr-2 cursor-pointer"
                                    [ngClass]="currentIndexTag == item ? 'bg-palette-blue-50 text-palette-blue-600' : 'text-palette-gray-500 hover:bg-palette-gray-100'">
                                    {{ (item == 0 ? 'COMMON.DEPART' : 'COMMON.RETURN') | translate }}
                                </button>
                            </ng-container>
                        </div>
                        <flight-schedule 
                            [bookingInfo]="bookingInfo"
                            [segments]="currentSegments"
                            [flightInfo]="flightInfo"
                            [isHidePNRCode]="false"
                            [isHideGDSSource]="false"
                            [isHideReferenceIdFailed]="false"
                            [segment_type]="currentSegmentType">
                        </flight-schedule >
            
                        <!-- Passengers -->
                        <app-passengers-info
                            class="!mt-2"
                            [flightDetail]="flightDetail"
                            [currentModeView]="currentIndexTag == 0 ? 'DEPART' : 'RETURN'"
                            [passengerList]="passengers"
                            [isModeBookingIssue]="true">
                        </app-passengers-info>
                    
                        <!-- Extra Baggage -->
                        <extra-baggage
                            [currentModeView]="currentIndexTag == 0 ? 'DEPART' : 'RETURN'"
                            [segments]="currentSegments"
                            [passengerInfo]="passengers">
                        </extra-baggage>
                        
                        <!-- Seat -->
                        <seat-selection 
                            [currentModeView]="currentIndexTag == 0 ? 'DEPART' : 'RETURN'"
                            [segments]="currentSegments"
                            [passengerInfo]="passengers">
                        </seat-selection>
                        
                        <!-- Meal -->
                        <meal-selection 
                            [currentModeView]="currentIndexTag == 0 ? 'DEPART' : 'RETURN'"
                            [segments]="currentSegments"
                            [passengerInfo]="passengers">
                        </meal-selection>
                    </ng-container>
                    <ng-container *ngIf="this.type === 'CHANGE_NAME'">
                        <p class="text-palette-gray-900 text-base font-semibold">{{ 'BOOKING_ISSUE.ISSUE_DETAIL' | translate }}</p>
                        <div class="relative overflow-x-auto !mt-3 border !rounded-lg border-palette-gray-200 !font-medium">
                            <table class="min-w-full">
                                <thead
                                    class="text-sm text-palette-gray-900 font-medium !rounded-t-lg bg-palette-gray-100">
                                    <tr class="border-b">
                                        <td class="rounded-tl-lg sticky left-0 z-10 bg-palette-gray-100 whitespace-nowrap">{{ 'BOOKING_HELPDESK.FLIGHT_ROUTE' | translate }}</td>
                                        <td class="whitespace-nowrap border-l">{{ 'BOOKING_ISSUE.OLD_PASSENGER_NAME' | translate }}</td>
                                        <td class="whitespace-nowrap border-l">{{ 'BOOKING_ISSUE.NEW_PASSENGER_NAME' | translate }}</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <ng-container
                                        *ngFor="let passenger of changeNameData; let index = index; let last = last">
                                        <tr [class.border-b]="!last">
                                            <td class="!py-2 sticky left-0 z-10 bg-white whitespace-nowrap">
                                                <p class="text-palette-gray-900 text-sm whitespace-nowrap">
                                                    {{ passenger.segment_iata_code_list[0][0] }} -> {{ passenger.segment_iata_code_list[0][1] }}
                                                </p>
                                            </td>
                                            <td class="!py-2 w-fit border-l">
                                                <p class="text-palette-gray-900 text-sm whitespace-nowrap">
                                                    {{ 'COMMON.' + passenger?.old_name?.title?.toUpperCase() | translate }} {{ passenger?.old_name?.last_name | uppercase }} {{ passenger?.old_name?.middle_and_first_name | uppercase }}
                                                </p>
                                            </td>
                                            <td class="!py-2 w-fit border-l">
                                                <p class="text-palette-amber-600 font-medium text-sm whitespace-nowrap">
                                                    {{ 'COMMON.' + passenger?.new_name?.title?.toUpperCase() | translate }} {{ passenger?.new_name?.last_name | uppercase }} {{ passenger?.new_name?.middle_and_first_name | uppercase }}
                                                </p>
                                            </td>
                                        </tr>
                                    </ng-container>
                                </tbody>
                            </table>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="this.type === 'ADD_ONS'">
                        <p class="text-palette-gray-900 text-base font-semibold">{{ 'BOOKING_ISSUE.ISSUE_DETAIL' | translate }}</p>
                        <ng-container *ngFor="let itinerary of addOnsData">
                            <p class="text-palette-gray-500 text-sm font-semibold !mt-3 !mb-2">{{ itinerary.origin }} -> {{ itinerary.destination }}</p>
                            <div class="relative overflow-x-auto border !rounded-lg border-palette-gray-200 !font-medium">
                                <table class="min-w-full">
                                    <colgroup>
                                        <col style="width: 40%" />
                                        <col style="width: 20%" />
                                        <col style="width: 40%" />
                                    </colgroup>
                                    <thead
                                        class="text-sm text-palette-gray-900 font-medium !rounded-t-lg bg-palette-gray-100">
                                        <tr class="border-b">
                                            <td class="rounded-tl-lg sticky left-0 z-10 bg-palette-gray-100 whitespace-nowrap">{{ 'BOOKING_ISSUE.PASSENGER_NAME' | translate }}</td>
                                            <td class="whitespace-nowrap border-l">{{ 'BOOKING_HELPDESK.FLIGHT_ROUTE' | translate }}</td>
                                            <td class="whitespace-nowrap border-l">{{ 'COMMON.ADD_ONS' | translate }}</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <ng-container
                                            *ngFor="let passenger of itinerary.addonByPassengers; let indexPassenger = index; let lastPassenger = last">
                                            <ng-container *ngFor="let segment of passenger.data; let indexSegment = index; let lastSegment = last">
                                                <tr>
                                                    <td [class.border-b]="lastSegment && !lastPassenger" class="!py-2 sticky left-0 z-10 bg-white whitespace-nowrap">
                                                        <p *ngIf="indexSegment == 0" class="text-palette-gray-900 text-sm whitespace-nowrap">
                                                            {{ 'COMMON.' + passenger.passengerInfo.title.toUpperCase() | translate }} {{ passenger.passengerInfo.last_name.toUpperCase() }} {{ passenger.passengerInfo.middle_and_first_name.toUpperCase() }}
                                                        </p>
                                                    </td>
                                                    <td [class.border-b]="!(lastPassenger && lastSegment)" class="!py-2 w-fit border-l">
                                                        <p class="text-palette-gray-900 text-sm whitespace-nowrap">
                                                            {{ segment.origin }} -> {{ segment.destination }}
                                                        </p>
                                                    </td>
                                                    <td [class.border-b]="!(lastPassenger && lastSegment)" class="!py-2 w-fit border-l">
                                                        <p *ngIf="segment?.seat" class="text-palette-gray-500 text-sm whitespace-nowrap">
                                                            {{ 'FLIGHT.PAYMENT.SEAT' | translate }}: <span class="text-palette-gray-900">{{ segment.seat.code }}</span>
                                                        </p>
                                                        <p *ngIf="segment?.extra_baggage" class="text-palette-gray-500 text-sm !mt-[2px] whitespace-nowrap">
                                                            {{ 'FLIGHT.PAYMENT.EXTRA_BAGGAGE_1' | translate }}: 
                                                            <span class="text-palette-gray-900">
                                                                <ng-container *ngIf="segment.extra_baggage?.description && (segment.extra_baggage?.description?.toUpperCase()?.includes('OVERSIZE') ||
                                                                    segment.extra_baggage?.description?.toUpperCase()?.includes('HLQK')); else normalWeight">
                                                                    {{ 'COMMON.OVERSIZE' | translate}} {{segment.extra_baggage.weight}}kg
                                                                </ng-container>
                                                                <ng-template #normalWeight>
                                                                    {{segment.extra_baggage?.weight}}kg
                                                                </ng-template>
                                                            </span>
                                                        </p>
                                                        <div *ngIf="segment?.meals" class="text-palette-gray-500 text-sm !mt-[2px] flex !gap-1">
                                                            <span class="whitespace-nowrap">{{ 'FLIGHT.PAYMENT.MEAL' | translate }}: </span>
                                                            <div class="flex flex-col !gap-1 w-fit">
                                                                <span *ngFor="let meal of segment.meals.meals; let last = last" class="text-palette-gray-900 whitespace-nowrap">
                                                                    {{ meal.meal_name }} x {{ meal.quantity }}<span *ngIf="!last">, </span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </ng-container>
                                        </ng-container>
                                    </tbody>
                                </table>
                            </div>
                        </ng-container>
                    </ng-container>
                </div>
            </div>
            <ng-container *ngIf="isLoading">
                <div class="flex-1 !px-6 !py-4 flex flex-col gap-5 max-h-[calc(100%-204px)] overflow-y-auto animate-pulse">
                    <div class="h-4 w-1/3 bg-gray-300 rounded"></div>
    
                    <div class="border-b border-dashed pb-5">
                        <div class="h-5 w-1/2 bg-gray-300 rounded mb-4"></div>
                        <div class="grid grid-cols-3 gap-3">
                            <div *ngFor="let _ of [1, 2, 3]" class="flex flex-col gap-1">
                                <div class="h-4 w-3/4 bg-gray-300 rounded"></div>
                                <div class="h-6 w-1/2 bg-gray-200 rounded"></div>
                            </div>
                        </div>
                    </div>
    
                    <div class="h-10 bg-gray-300 rounded"></div>
                    <div class="h-[150px] bg-gray-200 rounded"></div>
                    <div class="h-[150px] bg-gray-200 rounded"></div>
                </div>
            </ng-container>
        </div>
        <!-- FOOTER -->
        <div class="!px-6 !py-4 flex justify-end items-center">
            <button
                class="!h-11 !min-w-[88px] px-2 border border-palette-gray-300 
                    text-palette-gray-900 font-semibold rounded-lg hover:bg-palette-gray-200 
                    focus:outline-none focus:ring-2 focus:ring-palette-gray-300 focus:ring-opacity-50"
                (click)="handleHidePopup()">
                {{ 'COMMON.CLOSE' | translate }}
            </button>
        </div>
    </div>
</div>